import { Obscura } from '../../vendor';

import InboomaBaseAsyncCollection from './InboomaBaseAsyncCollection';
import Pricetariff from '../models/Pricetariff';

const PricetariffsProxy = Obscura.extend({

});

export default InboomaBaseAsyncCollection.extend({
  
    collectionName : 'pricetariffs',
    model : Pricetariff,
    proxy : PricetariffsProxy,
    url : '/pricetariffs',

    _pagination : {
        current_page : 0,
        sort : 'id',
        sortDirection : 'desc',
        has_next_page : false,
        has_prev_page : false,
        count : 0,
        limit : 50  
    },

});
  